import { render, staticRenderFns } from "./instructionsPdfOfflinexinyou.vue?vue&type=template&id=79a5ff7f&scoped=true&"
import script from "./instructionsPdfOfflinexinyou.vue?vue&type=script&lang=js&"
export * from "./instructionsPdfOfflinexinyou.vue?vue&type=script&lang=js&"
import style0 from "./instructionsPdfOfflinexinyou.vue?vue&type=style&index=0&id=79a5ff7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a5ff7f",
  null
  
)

export default component.exports